// extracted by mini-css-extract-plugin
export default {"productCarousel":"M1-z"};